import { AloArbo } from '@/models/alo/AloArbo';
import { AloArboLg } from '@/models/alo/AloArboLg';
import { AloPlat } from '@/models/alo/AloPlat';
import { ItemPanier } from '@/models/alo/ItemPanier';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BasePlat',  
  props: {
    plat:{
      type:Object,
      required:true
    },
    platSectionId:{
      type:Number,
      default:null
    },
    platArboId:{
      type:Number,
      default:null
    },
    platParentId:{
      type:Number,
      default:null
    },
    canAddFromArbo:{
      type:Function,
      default:(arbo:AloArbo) => false
    } 
  }
})
export default class BasePlat extends Vue {
  plat!:AloPlat
  platSectionId!:number|null 
  platArboId!:number|null
  platParentId!:number|null
  canAddFromArbo!:Function
  
  addToCart(itemPanier:ItemPanier){
    this.$emit("addToCart",itemPanier)    
  } 

  get arbosDic(){
    return this.$store.myGetters.arbosDic
  }

  get panier(){
    return this.$store.myGetters.panier
  }

  get canAdd() {
    return !this.platArboId || this.canAddFromArbo(this.arbosDic[this.platArboId])
  }  
  
  get printMode(){
    return this.$store.myGetters.printMode
  }
    
}
